import React, { useState } from 'react';
import DownloadProfile from '../Widgets/DownloadProfile';
import Notes from '../Widgets/Notes';
import AwardLevelFocus from '../Widgets/InstitutionalClassification/AwardLevelFocus';
import AcademicProgramMix from '../Widgets/InstitutionalClassification/AcademicProgramMix';
import GraduateAcademicProgramMix from '../Widgets/InstitutionalClassification/GraduateAcademicProgramMix';
import NonDegreeCredentials from '../Widgets/InstitutionalClassification/NonDegreeCredentials';
import SizeSettingHighestDegreeAwardedBanner from '../Widgets/InstitutionalClassification/SizeSettingHighestDegreeAwardedBanner';
import HistoricalClassifications from '../Widgets/InstitutionalClassification/HistoricalClassifications';
import TribalCollege from '../Widgets/InstitutionalClassification/TribalCollege';
import PanelTitle from './PanelTitle';
import Panel from './Panel';
import MethodologySimilarLinks from '../Widgets/MethodologySimilarLinks';

export default function InstitutionalClassification(props) {
    const institutionData = props.institutionData;

    return (
        <Panel className="institutional-classification">
            <div className="row">
                <div className="col-xs-12 col-sm-9">
                    <PanelTitle>Institutional Classification</PanelTitle>
                </div>
                <div className="col-xs-12 col-sm-3">
                    <DownloadProfile />
                </div>
            </div>
            <div className="row my-4">
                <div className="col-xs-12">
                    <div className='p-4 emphasisBox'>
                        <div className="">
                            <div className='row'>
                                <div className="col-xs-12 col-sm-9">
                                    <div>
                                        <strong>Institutional Classification:</strong><br />
                                        {institutionData.post_meta.ic2025.label}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-3">
                                    <MethodologySimilarLinks
                                        methodologyLink={'/carnegie-classification/basic-classification/'}
                                        similarLink={`/institutions/?ic2025[]=${institutionData.post_meta.ic2025.value}`}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 mb-4">
                    {/* Award Level Focus Widget */}
                    <AwardLevelFocus institutionData={institutionData} />
                </div>

                <div className="col-lg-6 mb-4">
                    {/* Academic Program Mix */}
                    <AcademicProgramMix institutionData={institutionData} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 mb-4">
                    {/* Graduate Academic Program Mix Widget */}
                    <GraduateAcademicProgramMix institutionData={institutionData} />
                </div>

                <div className="col-lg-6 mb-4">
                    {/* Non-degree Credentials Widget */}
                    <NonDegreeCredentials institutionData={institutionData} />
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 mb-4">
                    {/* Size Setting Highest Degree Awarded Banner Widget */}
                    <SizeSettingHighestDegreeAwardedBanner institutionData={institutionData} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 mb-4">
                    {/* Historical Classifications Widget */}
                    <HistoricalClassifications institutionData={institutionData} />
                </div>

                <div className="col-lg-6 mb-4">
                    <div className="h-100 d-flex flex-column">
                        <TribalCollege institutionData={institutionData} className="mb-4" />
                        <Notes field="institution-tab-notes" institutionData={institutionData} className="flex-grow-1" />
                    </div>
                </div>
            </div>
        </Panel>
    );
}